import moment from 'moment'
import { UsageData, DataPoint } from '../store/index'

/**
 * Generates usage data for a given type and year.
 *
 * @param {string} type - The type of usage data (e.g., 'electricity', 'water', 'districtheat').
 * @param {string} year - The optional year for which usage data should be retrieved. Defaults to the current year if not provided.
 * @returns {UsageData | null} - Returns a `UsageData` object with relevant details or `null` if the type is not recognized.
 */
const getUsageData = (type: string, year?: string): UsageData | null => {
  let usageData: UsageData | null = null

  /**
   * Defines the start date of the given year.
   * - Uses `year` if provided, otherwise defaults to the current year.
   * - Sets the date to the first day of the year.
   */
  const start = moment(year || moment().format('YYYY'), 'YYYY')
    .startOf('year')
    .format('YYYY-MM-DD')

  /**
   * Defines the end date of the given year.
   * - Uses `year` if provided, otherwise defaults to the current year.
   * - Sets the date to the last day of the year.
   */
  const end = moment(year || moment().format('YYYY'), 'YYYY')
    .endOf('year')
    .format('YYYY-MM-DD')

  const frame = 'year'
  const data: DataPoint[] = []

  if (type === 'electricity' || type === 'sahko') {
    usageData = {
      title: 'Sähkönkulutus',
      type: 'electricity',
      frame,
      level: 'month',
      unit: '',
      start,
      end,
      data,
    }
  } else if (type === 'water' || type === 'vesi') {
    usageData = {
      title: 'Vedenkulutus',
      type: 'water',
      frame,
      level: 'month',
      unit: 'kuutiota',
      start,
      end,
      data,
    }
  } else if (type === 'districtheat' || type === 'kaukolampo') {
    usageData = {
      title: 'Kaukolämmön kulutus',
      type: 'heat',
      frame,
      level: 'month',
      unit: '',
      start,
      end,
      data,
    }
  }

  if (usageData) return { ...usageData }

  return null
}

export default getUsageData
